//# sourceMappingURL=toc.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/toc/toc.interface.js
// module id = 1193
// module chunks = 4